<template>
  <div class="ccs-layout">
    <div class="ccs-layout ccs-4 ccs-layout--no-pad">
      <ccs-input class="ccs-9" type="autocomplete" label="Роли" :items="rolesForSelect"
        v-model="roleID" @change="onRoleSearch" placeholder="Введите 3 символа для поиска"/>
      <div class="ccs-3 button--add">
        <button class="ccs-button ccs-button--small ccs-12" @click="addRole">
          Добавить
        </button>
      </div>
      <div class="ccs-layout ccs-12 ccs-layout--scroll">
        <div class="ccs-tag ccs-tag--normal" v-for="(role, index) in user.roles" :key="index"
          @click="removeRole(role)">
          {{role.name}}
        </div>
      </div>
    </div>
    <div class="ccs-layout ccs-4 ccs-layout--no-pad">
      <ccs-input class="ccs-9" type="autocomplete" label="Разрешения" :items="permissionsForSelect"
        v-model="permissionSlug" @change="onPermissionSearch"
        placeholder="Введите 3 символа для поиска"/>
      <div class="ccs-3 button--add">
        <button class="ccs-button ccs-button--small ccs-12" @click="addPermission">
          Добавить
        </button>
      </div>
      <div class="ccs-layout ccs-12 ccs-layout--scroll">
        <div class="ccs-tag ccs-tag--normal" v-for="(permission, index) in user.permissions"
          :key="index" @click="removePermission(permission)">
          {{permission.name}}
        </div>
      </div>
    </div>
    <div class="ccs-layout ccs-4 ccs-layout--no-pad">
      <ccs-input class="ccs-9" type="autocomplete" label="Компетенции" :items="skillsForSelect"
        v-model="skillID" @change="onSkillSearch" placeholder="Введите 3 символа для поиска"/>
      <div class="ccs-3 button--add">
        <button class="ccs-button ccs-button--small ccs-12" @click="addSkill">
          Добавить
        </button>
      </div>
      <div class="ccs-layout ccs-12 ccs-layout--scroll">
        <div class="ccs-tag ccs-tag--normal" v-for="(skill, index) in user.skills" :key="index"
          @click="removeSkill(skill)">
          {{skill.name_rus}}
        </div>
      </div>
    </div>
    <div class="ccs-layout ccs-layout--no-pad">
      <div>
        <button class="ccs-button" @click="$emit('close')">
          Закрыть
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import AutocompleteParent from '@/mixins/AutocompleteParent.js';

import Input from '@/components/forms/Input.vue';

export default {
  name: 'CreateUser',
  mixins: [AutocompleteParent],
  components: {
    'ccs-input': Input,
  },
  data() {
    return {
      roleID: undefined,
      rolesForSelect: [],
      permissionSlug: undefined,
      permissionsForSelect: [],
      skillID: undefined,
      skillsForSelect: [],
      user: {}
    }
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapActions('users', [
      'addRoleToUser',
      'deleteRoleFromUser',
      'addPermissionToUser',
      'deletePermissionFromUser',
      'addSkillToUser',
      'deleteSkillFromUser',
    ]),
    async onRoleSearch(text) {
      [this.rolesForSelect] = await this.getAutocompleteData('/v1/roles/list', text);
    },
    async onPermissionSearch(text) {
      [this.permissionsForSelect] = await this.getAutocompleteData('/v1/permissions/list', text,
        'slug');
    },
    async onSkillSearch(text) {
      [this.skillsForSelect] = await this.getAutocompleteData('/v1/skills/list', text,
        'id', 'name_rus');
    },
    async submit() {
      if (this.user.id) {
        await this.editUser();
      } else {
        await this.addUser();
      }
    },
    // ---------------------------
    // Roles
    // ---------------------------
    async addRole() {
      try {
        await this.addRoleToUser({
          userID: this.user.id,
          roleID: this.roleID,
        });
        const selectedRole = this.rolesForSelect.find(item => item.prop === this.roleID);
        this.user.roles.push({
          id: selectedRole.prop,
          name: selectedRole.dispalyText || selectedRole.searchText,
        });
        this.roleID = undefined;
        this.$toasted.success('Роль назначена');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
    async removeRole(role) {
      try {
        await this.deleteRoleFromUser({
          userID: this.user.id,
          roleID: role.id,
        });
        this.user.roles = this.user.roles.filter(item => {
          return item.id !== role.id;
        });
        this.$toasted.success('Роль удалена');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
    // ---------------------------
    // Permissions
    // ---------------------------
    async addPermission() {
      try {
        await this.addPermissionToUser({
          userID: this.user.id,
          permissionID: this.permissionSlug,
        });
        const selectedPermission = this.permissionsForSelect.find(
          item => item.prop === this.permissionSlug,
        );
        this.user.permissions.push({
          slug: selectedPermission.prop,
          name: selectedPermission.dispalyText || selectedPermission.searchText,
        });
        this.permissionSlug = undefined;
        this.$toasted.success('Разрешение назначено');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
    async removePermission(permission) {
      try {
        await this.deletePermissionFromUser({
          userID: this.user.id,
          permissionID: permission.slug,
        });
        this.user.permissions = this.user.permissions.filter(item => {
          return item.slug !== permission.slug;
        });
        this.$toasted.success('Разрешение удалено');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
    // ---------------------------
    // Skills
    // ---------------------------
    async addSkill() {
      try {
        await this.addSkillToUser({
          userID: this.user.id,
          skillID: this.skillID,
        });
        const selectedSkill = this.skillsForSelect.find(item => item.prop === this.skillID);
        this.user.skills.push({
          id: selectedSkill.prop,
          name_rus: selectedSkill.dispalyText || selectedSkill.searchText,
        });
        this.skillID = undefined;
        this.$toasted.success('Компетенция привязана');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
    async removeSkill(skill) {
      try {
        await this.deleteSkillFromUser({
          userID: this.user.id,
          skillID: skill.id,
        });
        this.user.skills = this.user.skills.filter(item => {
          return item.id !== skill.id;
        });
        this.$toasted.success('Компетенция отвязана');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
  },
  mounted() {
    this.user = this.$props.data;
  },
}
</script>

<style lang="scss" scoped>
.button--add {
  margin-top: 22px;
}
</style>